module.exports = __webpack_public_path__ + "static/media/slider-18.7801462b.jpg";